import { useEffect, useMemo, useState } from "react";
import moment, { Moment } from "moment";
import {
  type UseEventLayoutsParams,
  type UseEventLayoutsResult,
  computeEventLayouts,
} from "./eventLayouts.utils";

export type {
  PrioritySchedulerEventLayout,
  UseEventLayoutsParams,
  UseEventLayoutsResult,
  ComputeEventLayoutsParams,
} from "./eventLayouts.utils";
export { classifyEvent, computeEventLayouts } from "./eventLayouts.utils";

const DEFAULT_STACK_GAP_PX = 0;
const CURRENT_TIME_REFRESH_MS = 15_000;

function useCurrentTime(): Moment {
  const [now, setNow] = useState(() => moment());

  useEffect(() => {
    const id = setInterval(() => setNow(moment()), CURRENT_TIME_REFRESH_MS);
    return () => clearInterval(id);
  }, []);

  return now;
}

export function useEventLayouts({
  events,
  hourHeight,
  columnDate,
  dayStartTime,
  dayEndTime,
  stackGapPx = DEFAULT_STACK_GAP_PX,
  templateWindowsById,
  disabledSlots,
}: Readonly<UseEventLayoutsParams>): UseEventLayoutsResult {
  const now = useCurrentTime();

  return useMemo(
    () =>
      computeEventLayouts({
        events,
        hourHeight,
        columnDate,
        dayStartTime,
        dayEndTime,
        stackGapPx,
        templateWindowsById,
        disabledSlots,
        now,
      }),
    [
      events,
      hourHeight,
      columnDate,
      dayStartTime,
      dayEndTime,
      stackGapPx,
      templateWindowsById,
      disabledSlots,
      now,
    ]
  );
}
